import {useEffect, useRef} from 'react'
import {Tab} from 'bootstrap'
import {
  MenuComponent,
  DrawerComponent,
  ScrollComponent,
  ScrollTopComponent,
  StickyComponent,
  ToggleComponent,
  SwapperComponent,
} from '../assets/ts/components'
import {ThemeModeComponent} from '../assets/ts/layout'
import {useLocation} from 'react-router-dom'
import {useLayout} from './core'

// module-level — survives component remounts caused by Clerk
let isBootstrapped = false

export function MasterInit() {
  const {config} = useLayout()
  const location = useLocation()
  const isFirstRun = useRef(true)

  const pluginsInitialization = () => {
    isFirstRun.current = false
    ThemeModeComponent.init()
    setTimeout(() => {
      ToggleComponent.bootstrap()
      ScrollTopComponent.bootstrap()
      DrawerComponent.bootstrap()
      StickyComponent.bootstrap()
      MenuComponent.bootstrap()
      ScrollComponent.bootstrap()
      SwapperComponent.bootstrap()
      document.querySelectorAll('[data-bs-toggle="tab"]').forEach((tab) => {
        Tab.getOrCreateInstance(tab)
      })
      isBootstrapped = true
    }, 500)
  }

  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false
      if (!isBootstrapped) {
        pluginsInitialization()
      }
    }
  }, [config])

  useEffect(() => {
    if (!isFirstRun.current) {
      const timer = setTimeout(() => {
        if (!isBootstrapped) {
          MenuComponent.bootstrap()
          DrawerComponent.bootstrap()
          ScrollComponent.bootstrap()
          StickyComponent.bootstrap()
          ToggleComponent.bootstrap()
          SwapperComponent.bootstrap()
          isBootstrapped = true
        } else {
          MenuComponent.reinitialization()
          DrawerComponent.reinitialization()
          ScrollComponent.reinitialization()
          StickyComponent.reInitialization()
          ToggleComponent.reinitialization()
          SwapperComponent.reinitialization()
        }
      }, 600)
      return () => clearTimeout(timer)
    }
  }, [location.pathname])

  return <></>
}
